// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-chaxun[data-v-8a87a2ce]{display:flex;justify-content:center;align-items:center;border:1px solid #ccc;padding:20px;width:100%;margin-top:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
